import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";

const ApplicationFeeList = ({ applicationFeeDetails }) => {

    const applicationFeeListColumns = [
      {
        field: "applicationFeeId",
        headerName: "Application Fee ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalApplicationId",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "applicationNumber",
        headerName: "Application Number",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "feeType",
        headerName: "Fee Type",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "feeAmount",
        headerName: "Fee Amount",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
    ];

    return(<>
         <AccordianContainer
          id="accord"
          title="Application Fee List"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={(applicationFeeDetails !== undefined && applicationFeeDetails !== null) ?
              applicationFeeDetails.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []}
            columns={applicationFeeListColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.applicationFeeId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
    </>);
}

export default ApplicationFeeList;